
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { getAllPosts, getAllCategories } from "@/lib/contentQueries";
import Head from "next/head";
import useTranslation from "next-translate/useTranslation";
import { Container } from "../../components/util/container";
import { Section } from "../../components/util/section";
import Posts from "../../components/blog/BlogPosts";
import Header from "../../components/blog/Header";
import { client } from "../../../tina/__generated__/client";
import { isSafeContentSegment } from "@/lib/contentRouteSafety";
const MIN_INDEXABLE_TOPIC_POSTS = 3;
export default function TopicLandingPage({ category, posts }) {
    const { t } = useTranslation("common");
    if (!category)
        return null;
    const shouldNoindex = posts.length < MIN_INDEXABLE_TOPIC_POSTS;
    return (<Section className="flex-1">
      {shouldNoindex && (<Head>
          <meta name="robots" content="noindex,follow"/>
        </Head>)}
      <Header>
        <h1 className="relative w-full mb-4 text-3xl font-extrabold tracking-normal text-center text-white md:text-5xl title-font">
          {t(category.category)}
        </h1>
        <div className="max-w-2xl mx-auto text-sm font-normal text-center text-gray-300 md:text-base">
          {category.description}
        </div>
      </Header>
      <Container size="medium" width="small">
        {posts.length > 0 ? (<Posts data={posts} groupBySubtopic mode="guides"/>) : (<div className="px-6 py-8 mt-10 text-sm text-gray-600 bg-white border border-slate-200 rounded-xl">
            New articles for this topic are coming soon.
          </div>)}
      </Container>
    </Section>);
}
export const getStaticPaths = async () => {
    const categoryConnection = await getAllCategories();
    const paths = categoryConnection.data.categoryConnection.edges
        .filter((category) => category.node._sys.filename !== "news" &&
        category.node._sys.filename !== "openings")
        .map((category) => ({
        params: { topic: category.node._sys.filename },
        locale: "en",
    }));
    return {
        paths,
        fallback: process.env.CONTENT_SNAPSHOT_BUILD !== "true" ? "blocking" : false,
    };
};
const getStaticProps = async ({ params }) => {
    const { topic } = params;
    if (!isSafeContentSegment(topic)) {
        return { notFound: true };
    }
    if (topic === "news") {
        return { redirect: { destination: "/news", permanent: true } };
    }
    let categoryResponse;
    try {
        categoryResponse = await client.queries.category({
            relativePath: `${topic}.md`,
        });
    }
    catch {
        return { notFound: true };
    }
    const category = categoryResponse?.data?.category;
    if (!category)
        return { notFound: true };
    const postsResponse = await getAllPosts({
        filter: {
            locale: { eq: "en" },
            category: { category: { slug: { eq: topic } } },
        },
    });
    return {
        props: {
            category,
            posts: postsResponse.data.postConnection.edges,
        },
    };
};

    async function __Next_Translate__getStaticProps__1a0fc0d5409__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/[topic]/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0fc0d5409__ as getStaticProps }
  